import React from "react";
import { thisBaseURL } from "../../utils/helper.js";

function LandUseField({defaultCountry, heading, year, value, sourceRef}){
	return(
		<tr>
			<td>{heading}</td>
			<td width="25%">
				{value}
				<small>&nbsp;({year})</small>
				{sourceRef && sourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+sourceRef}>{sourceRef}</a></small>
				: ""}
			</td>
		</tr>
	)
}

export default LandUseField;